import { Navigate, Outlet, useLocation } from "react-router";
import {
  CUSTODY_ONLY_ROLES,
  INVEST_ROLES,
  sessionStorageKeys,
  TRADE_DASHBOARD_ACCESS_ROLES,
} from "../constants";
import { paths } from "../paths";
import {
  parseJwt,
  getUserPermissions,
  hasTheseRolesOnlyInAnyOrg,
} from "@archax/web-lib";

const UNAUTHORIZED_ROUTES = [
  paths.login,
  paths.register,
  paths.setupMfa,
  paths.resetPassword,
  paths.setPassword,
];

export const UnauthorisedRoutesGuard = () => {
  const token = globalThis.sessionStorage.getItem(sessionStorageKeys.token);
  const location = useLocation();
  const isMobile = window.innerWidth <= 768;

  const roles = token ? getUserPermissions(token) : [];
  const primaryOrgRoles = roles[0]?.[1] ?? [];
  const hasTradingAccess = TRADE_DASHBOARD_ACCESS_ROLES.some((role: string) =>
    primaryOrgRoles.includes(role),
  );
  const hasCustodyAccess =
    token && hasTheseRolesOnlyInAnyOrg(CUSTODY_ONLY_ROLES, token);
  const hasInvestAccess = INVEST_ROLES.some((role: string) =>
    primaryOrgRoles.includes(role),
  );

  // if there isn't a token OR there is a token and younger than 3 seconds
  // the 3 second is to avoid a flash of the initial redirect from login use-landing-page hook
  if (!token || (token && Date.now() / 1000 - parseJwt(token).iat < 2)) {
    return <Outlet />;
  }

  const getRedirectPath = () => {
    const isLoginPageOnDesktop =
      UNAUTHORIZED_ROUTES.includes(location.pathname) && token && !isMobile;

    if (hasTradingAccess) {
      return paths.simplifiedView;
    }

    if (hasInvestAccess) {
      // Special case: redirect to custody for invest users on login page (mobile behavior)
      return isLoginPageOnDesktop ? paths.custody : paths.tradeDashboard;
    }

    if (hasCustodyAccess) {
      return paths.custody;
    }

    return paths.accountOverview;
  };

  return <Navigate to={getRedirectPath()} replace />;
};
